import { academyApiUrl, isAcademySitePath } from "./academyBackend";

const PLATFORM_API_BASE = (
  process.env.REACT_APP_BACKEND_URL ||
  "https://greatleadersplatformbackend.onrender.com"
).replace(/\/$/, "");

function eventsEndpoint() {
  if (typeof window !== "undefined" && isAcademySitePath(window.location.pathname)) {
    return academyApiUrl("/api/analytics/events");
  }
  return `${PLATFORM_API_BASE}/api/company-site-analytics/events`;
}

const VISITOR_KEY = "gl_site_vid";
const SESSION_KEY = "gl_site_sid";
const SESSION_AT_KEY = "gl_site_sid_at";
const SESSION_MS = 30 * 60 * 1000;

function uuid() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  } catch {
    // private mode
  }
  return `id_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

function read(storage, key) {
  try {
    return storage.getItem(key) || "";
  } catch {
    return "";
  }
}

function write(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    // blocked storage
  }
}

function visitorId() {
  let id = read(window.localStorage, VISITOR_KEY);
  if (!id) {
    id = uuid();
    write(window.localStorage, VISITOR_KEY, id);
  }
  return id;
}

function sessionId() {
  const now = Date.now();
  const lastAt = Number(read(window.sessionStorage, SESSION_AT_KEY) || 0);
  let id = read(window.sessionStorage, SESSION_KEY);
  if (!id || !lastAt || now - lastAt > SESSION_MS) {
    id = uuid();
    write(window.sessionStorage, SESSION_KEY, id);
  }
  write(window.sessionStorage, SESSION_AT_KEY, String(now));
  return id;
}

export function currentEnvironment() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/dev" || path.startsWith("/dev/")) return "dev";
  if (path === "/test" || path.startsWith("/test/")) return "test";
  return "prod";
}

function deviceFromWidth() {
  const width = window.innerWidth || 0;
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}

function utmFromLocation() {
  try {
    const params = new URLSearchParams(window.location.search);
    return {
      utmSource: params.get("utm_source") || "",
      utmMedium: params.get("utm_medium") || "",
      utmCampaign: params.get("utm_campaign") || "",
    };
  } catch {
    return { utmSource: "", utmMedium: "", utmCampaign: "" };
  }
}

export function trackSiteEvent(type, extra = {}) {
  if (typeof window === "undefined") return;
  if (navigator.webdriver) return;
  const utm = utmFromLocation();
  const payload = {
    type: type || "pageview",
    visitorId: visitorId(),
    sessionId: sessionId(),
    environment: extra.environment || currentEnvironment(),
    path: extra.path || "/",
    title: extra.title || "",
    referrer: extra.referrer != null ? extra.referrer : document.referrer || "",
    device: deviceFromWidth(),
    width: window.innerWidth || 0,
    ...utm,
  };
  try {
    fetch(eventsEndpoint(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: "cors",
    }).catch(() => {});
  } catch {
    // tracking must not break the page
  }
}
